// Module
var code = "<go-banner ng-repeat=\"banner in $ctrl.banners\" banner=\"banner\"></go-banner>";
// Exports
module.exports = code;